import Parser from 'html-react-parser';
import l from '../../../../lang';
import FolderExclamationIcon from '../../../../assets/icons/folder-exclamation.svg?url';
import '../../transactions/empty/styles.scss';

export const EmptyNoFound = () => (
  <div className="empty__no_transactions">
    <img src={FolderExclamationIcon} alt="" />
    {Parser(l('clients.noClients.found'))}
  </div>
);
